var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-viewer"},[_c('prism',{ref:"codebox",staticClass:"code-preview",style:(_vm.maxLinesStl),attrs:{"language":"json"}},[_vm._v(_vm._s(_vm.fullview))]),_vm._v(" "),_c('a',{staticClass:"view-full-screen",attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.viewFullScreen($event)}}},[_vm._v("\n    OPEN\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f0b3011","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/data-viewer.vue
// module id = 1240
// module chunks = 0